export default __webpack_public_path__ + "static/media/menu.3ad61a96.svg";